/**
 * Client-side billing helpers (mirrors window.__pmBillingState from EmailVerificationGate).
 */

export function getBillingState() {
  if (typeof window === "undefined") return null;
  return window.__pmBillingState || null;
}

export function openSubscriptionGate(stage = "subscription", planId = null) {
  try {
    const detail = { stage, planId: planId || null };
    if (typeof window.__pmOpenSubscriptionGate === "function") {
      window.__pmOpenSubscriptionGate(detail);
      return;
    }
    window.dispatchEvent(new CustomEvent("pm:require-subscription", { detail }));
  } catch (_) {}
}

/** True when trial ended and there is no active paid plan. */
export function isPaywallRequired() {
  const billing = getBillingState();
  return !!billing?.paywallRequired;
}

export function hasFeatureAccess(featureKey) {
  const billing = getBillingState();
  if (!billing?.authed) return false;
  if (billing.paywallRequired) return false;
  if (billing.hasAccess && typeof billing.hasAccess === "object") {
    return !!billing.hasAccess[featureKey];
  }
  return !!billing.hasPaidAccess;
}

export function ensureFeatureAccess(featureKey, stage = featureKey) {
  if (hasFeatureAccess(featureKey)) return true;
  openSubscriptionGate(stage);
  return false;
}
